
export  const  prepareData = (object) =>{
    return object.map((org) => {
        if (org.organizationProperties) {
            const organizationProperties = org.organizationProperties.reduce((acc, currentValue) => {
                return {...acc, [currentValue.propertyName]: currentValue.propertyValue, [currentValue.propertyName+"_id"]:currentValue.id};
            }, {});

            return {...org, organizationProperties};
        }
        return org;
    })
}